module.exports = __webpack_public_path__ + "static/media/sp18.22104b94.JPG";